import React from 'react';
import { connect } from 'react-redux';

import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { context } from '@Selectors/StateParamsSelectors';
import {
  syncAllChunksWithGroups,
  deselectAllChunksOfFilter,
  updateGroupByIdInChunksOfFilter,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersActions';
import NewAuthorCheckboxesDialog from '@Containers/ResultsFilters/ResultsFiltersComponents/NewAuthorCheckboxesDialog/NewAuthorCheckboxesDialog';
import {
  filter,
  sorting,
  maxSize,
  chunksCount,
  sortingType,
  filterTitle,
  disableAscending,
  disableDescending,
  activeChunkFactory,
  activeChunkIndexAsString,
  activeChunkIndexAsInteger,
  propsForDisableControlsFactory,
  customGroups,
  customGroupsData,
  activeCustomGroupIndex,
  activeCustomGroupLetter,
  customGroupsWithByValueSortingFactory,
} from './BarChartCheckboxesDialogSelectors';

import {
  limitTo,
  exclude,
  setActiveChunkId,
  setChunksSorting,
  getGroupsAsChunks,
  setChunksSortingType,
  getCustomGroupsData,
  setActiveCustomGroupIndex,
  openAffiliationFilter,
} from './BarChartCheckboxesDialogActions';

import { barChartCheckboxesDialogHandlers, barChartCheckboxesDialogLifecycle, withFeatureSwitchers } from './HOCs';

import BarChartCheckboxesDialog from './BarChartCheckboxesDialog';

export function BarChartCheckboxesDialogContainer(props) {
  // eslint-disable-next-line no-shadow
  const { newAuthorSearchFilterEnabled, filter } = props;
  if (!filter) {
    return null; // If filter is not defined, do not render the dialog
  }
  return newAuthorSearchFilterEnabled ? <NewAuthorCheckboxesDialog {...props} /> : <BarChartCheckboxesDialog {...props} />;
}

function mapStateToProps() {
  const activeChunk = activeChunkFactory();
  const { selectedCount, disableLimitTo, disableExclude, disableClearSelected } = propsForDisableControlsFactory();
  const customGroupsWithByValueSorting = customGroupsWithByValueSortingFactory();

  const structureSelector = createStructuredSelector({
    filter,
    sorting,
    maxSize,
    filterTitle,
    sortingType,
    chunksCount,
    activeChunk,
    selectedCount,
    disableExclude,
    disableLimitTo,
    disableAscending,
    disableDescending,
    disableClearSelected,
    activeChunkIndexAsString,
    activeChunkIndexAsInteger,
    context,
    customGroups,
    customGroupsData,
    activeCustomGroupIndex,
    activeCustomGroupLetter,
    customGroupsWithByValueSorting,
  });

  return structureSelector;
}

const mapDispatchToProps = {
  limitTo,
  exclude,
  setActiveChunkId,
  setChunksSorting,
  getCustomGroupsData,
  getGroupsAsChunks,
  setChunksSortingType,
  syncAllChunksWithGroups,
  deselectAllChunksOfFilter,
  updateGroupByIdInChunksOfFilter,

  setActiveCustomGroupIndex,
  openAffiliationFilter,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  barChartCheckboxesDialogHandlers,
  barChartCheckboxesDialogLifecycle,
  withFeatureSwitchers
)(BarChartCheckboxesDialogContainer);
